import { FC } from 'react';
import PageHeader from '../Headers/PageHeader';
import DashboardSkeleton from './DashboardSkeleton';

export enum InnerPageSkeletonContentType {
  Dashboard,
}

const InnerPageSkeleton: FC<{
  type?: InnerPageSkeletonContentType;
  title: string | React.ReactElement<any>;
  breadCrumbsLinks: { title: string; link?: string }[];
}> = ({ type, title, breadCrumbsLinks }) => {
  const getContent = () => {
    switch (type) {
      case InnerPageSkeletonContentType.Dashboard:
        return <DashboardSkeleton />;

      default:
        return <DashboardSkeleton />;
    }
  };
  return (
    <div className="flex overflow-hidden h-inner-screen  ">
      <div className="w-52 bg-white border-e shadow-lg h-full border-warmGray-200 p-4">
        <div role="status" className=" animate-pulse spac-y-4">
          <div className="h-6 bg-gray-200 rounded-md dark:bg-gray-700 w-24 mb-6"></div>
          <div className="h-4 bg-gray-200 rounded-md dark:bg-gray-700 w-36 mb-4"></div>
          <div className="h-4 bg-gray-200 rounded-md dark:bg-gray-700 w-36 mb-4"></div>
          <div className="h-4 bg-gray-200 rounded-md dark:bg-gray-700 w-36 mb-4"></div>
          <div className="h-6 bg-gray-200 rounded-md dark:bg-gray-700 w-24 mb-6"></div>
          <div className="h-4 bg-gray-200 rounded-md dark:bg-gray-700 w-36 mb-4"></div>
          <div className="h-4 bg-gray-200 rounded-md dark:bg-gray-700 w-36 mb-4"></div>
          <div className="h-6 bg-gray-200 rounded-md dark:bg-gray-700 w-24 mb-6"></div>
          <div className="h-4 bg-gray-200 rounded-md dark:bg-gray-700 w-36 mb-4"></div>
          <div className="h-4 bg-gray-200 rounded-md dark:bg-gray-700 w-36 mb-4"></div>
          <div className="h-4 bg-gray-200 rounded-md dark:bg-gray-700 w-36 mb-4"></div>
          <span className="sr-only">Loading...</span>
        </div>
      </div>
      <div className="flex-grow overflow-y-auto  overflow-x-hidden">
        <PageHeader title={title} breadCrumbsLinks={breadCrumbsLinks} />
        <div className={`py-4 w-full md:px-8 px-4   h-full    `}>
          {getContent()}
        </div>
      </div>
    </div>
  );
};
export default InnerPageSkeleton;
